/** Vendor bundles Segment's device-mode destinations inject at runtime — nothing in this repo loads them, and their unhandled rejections reach our global handler. */
export const THIRD_PARTY_SCRIPT_URL_PATTERNS = [/app\.factors\.ai/, /analytics\.tiktok\.com/]
